import '@babel/polyfill';
import '../../upgrade';
import attachFastClick from 'fastclick';
import React from 'react';
import ReactDom from 'react-dom';
import Index from './Index';
import '../../native-interact/web-interface';
import '../../styles/reset.scss';
import './dev.scss';

import { readStore } from '../../mobx/stores/rf';
import { bluetoothStore, bluetoothConnectStore } from '../../mobx/stores/bluetooth';
import { parkStore } from '../../mobx/stores/park';
import { automatorStore } from '../../mobx/stores/automator';
import { globalStore } from '../../mobx/stores/global';
import { geoStore } from '../../mobx/stores/geo';
import nativeInterface from '../../native-interact/native';

// import { noOperateDone, quit } from './js/utils';

// fix: 300ms延迟
// fix: ios12 webivew input框focus时点击其他区域未失焦
attachFastClick(document.body);

nativeInterface.setStatusBarColor('#000000');

ReactDom.render(
  <Index
    readStore={readStore}
    bluetoothStore={bluetoothStore}
    bluetoothConnectStore={bluetoothConnectStore}
    parkStore={parkStore}
    automatorStore={automatorStore}
    globalStore={globalStore}
    geoStore={geoStore}
  />,
  document.getElementById('root')
);

// 页面无操作5分钟后退出界面
// TODO 添加需要判断当前是否有正在操作的动作在后台执行
// noOperateDone(5 * 60 * 1000, quit);
